function responseClassification(status, contentType) {
  if ([408, 504, 522, 524].includes(Number(status))) return "timeout";
  if (Number(status) >= 500) return "server_error";
  if (!String(contentType || "").toLowerCase().includes("json")) {
    return "invalid_response_type";
  }
  return "request_error";
}

function friendlyMessage(classification) {
  if (classification === "timeout") {
    return "Zeitüberschreitung beim Verarbeiten dieser Saison.";
  }
  if (classification === "invalid_response_type") {
    return "Der Server hat keine gültige Datenantwort geliefert.";
  }
  return "Technischer Abruffehler.";
}

function requestError(endpoint, response, classification, details = {}) {
  const error = new Error(friendlyMessage(classification));
  error.diagnosis = {
    success: false,
    endpoint,
    http_status: Number(response?.status) || null,
    content_type: response?.headers?.get?.("content-type") || null,
    response_type: classification,
    message: error.message,
    ...details,
  };
  return error;
}

export async function readDataMaintenanceResponse(response, endpoint) {
  const contentType = response?.headers?.get?.("content-type") || "";
  const classification = responseClassification(response?.status, contentType);

  if (!String(contentType).toLowerCase().includes("json")) {
    throw requestError(endpoint, response, classification);
  }

  let result;
  try {
    result = await response.json();
  } catch {
    throw requestError(
      endpoint,
      response,
      classification === "request_error" ? "invalid_json" : classification,
    );
  }

  if (!response.ok) {
    throw requestError(endpoint, response, classification, {
      server_message:
        typeof result?.message === "string" ? result.message.slice(0, 300) : null,
    });
  }

  return result;
}

export function dataMaintenanceIssueDetails(error, fallback = {}) {
  return {
    ...fallback,
    ...(error?.diagnosis || {}),
    message: error?.message || fallback.message || "Technischer Abruffehler.",
  };
}

export function completedEvaluationResult(result, fixtureId) {
  if (result?.success !== true) return null;
  const fixtureResult = result?.results?.find(
    (item) => Number(item?.fixture_id) === Number(fixtureId),
  );
  if (
    !fixtureResult ||
    fixtureResult?.auxiliary_error ||
    fixtureResult?.operation_state !== "complete" ||
    fixtureResult?.finalized !== true ||
    Number(fixtureResult?.status) !== 5
  ) return null;
  return fixtureResult;
}
